import { SodiumPlus } from "sodium-plus";

let sodium : SodiumPlus

async function auto() {
    return sodium ?? (sodium = await SodiumPlus.auto());
}

export default auto;